// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Link-module--bx--text-truncate--end--OS2oW";
export var bxTextTruncateFront = "Link-module--bx--text-truncate--front--cDgme";
export var link = "Link-module--link--LCIL8";